import React, { useEffect, useMemo } from 'react';

import { ControlLabel } from 'react-bootstrap';
import styled from 'styled-components';
import Select from 'react-select';

import { useFetchData } from '../../../infrastructure/hooks/useFetchData';
import { City } from '../../../schemas/CitySchema';
import { ApiStatus } from '../../../infrastructure/constants/apiStatus';
import { getCities } from '../../../services/CitiesService';
import { Activity } from '../../../types/Activity';

type Props = {
  handleChangeCity(city: string): void;
} & Partial<Pick<Activity, 'city'>>;

const Container = styled.div`
  width: 80%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  .basic-single {
    flex: 1;
  }
  padding: 0 0 24px 0;
`;

export default function CitySelector({ city, handleChangeCity }: Props) {
  const [apiStatus, cities = [], fetchCities, refetch] = useFetchData<City[]>();

  const isLoading = apiStatus === ApiStatus.loading;
  const isError = apiStatus === ApiStatus.error;

  useEffect(() => {
    fetchCities(() => getCities());
  }, [fetchCities]);

  const options = useMemo(() => {
    return cities.map(city => ({
      value: city.name,
      label: city.name,
    }));
  }, [cities]);

  const selectedOption = options.find(option => option.value === city);

  if (isError) {
    return (
      <Container>
        <h1>Error loading cities </h1>
        <button onClick={refetch}>Retry</button>
      </Container>
    );
  }

  return (
    <Container>
      <ControlLabel>City:</ControlLabel>
      <Select
        value={selectedOption}
        className='basic-single'
        classNamePrefix='select'
        isLoading={isLoading}
        isSearchable
        name='city'
        onChange={option => {
          if (!option?.value) return;
          handleChangeCity(option.value);
        }}
        placeholder='Select city...'
        loadingMessage={() => 'Loading cities...'}
        options={options}
      />
    </Container>
  );
}
